import loginBackground from './loginBackground.jpg';

/**
 * Sushi photo behind the login card. Bundled via webpack so the URL cannot 404
 * from public-path quirks, and painted at z-0 (not negative z-index) so it
 * cannot fall behind the page canvas.
 */
const AuthBackground = () => (
  <img
    src={loginBackground}
    alt=""
    aria-hidden="true"
    className="pointer-events-none absolute top-0 left-0 z-0 max-w-none select-none"
  />
);

export default AuthBackground;
